<template>
  <div class="bussiness-box">
    <el-row>
      <el-col :span="24">
        <div class="top-box">更新时间: {{updateTime}}</div>
      </el-col>
    </el-row>
    <el-tabs v-model="country" @tab-click="handleClick">
      <el-tab-pane label="美国" name="1"></el-tab-pane>
      <el-tab-pane label="加拿大" name="2"></el-tab-pane>
    </el-tabs>
    <el-table :data="tableData" :height="screenHeight" style="width: 100%" border :row-style="setRowStyle" cell-class-name="table-cell" row-class-name="table-row" header-cell-class-name="table-header-cell">
      <el-table-column type='index' label="排名" width="50px">
      </el-table-column>
      <el-table-column prop="shopName" label="卖家名称">
      </el-table-column>
      <el-table-column label="前100产品数量">
        <template v-slot="scope">
          <el-link :underline="false" type="primary" size="small" :href="'/client/commodityMgmt?shopName='+scope.row.shopName+'&rank=100'">{{scope.row.limitRankTotalCommodityTopHundredCount}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="前1000产品数量">
        <template v-slot="scope">
          <el-link :underline="false" type="primary" size="small" :href="'/client/commodityMgmt?shopName='+scope.row.shopName+'&rank=1000'">{{scope.row.limitRankTotalCommodityCount}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="总产品数量">
        <template v-slot="scope">
          <el-link :underline="false" type="primary" size="small" :href="'/client/commodityMgmt?shopName='+scope.row.shopName">{{scope.row.totalCommodityCount}}</el-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  rankModules
} from "@r"
export default {
  data() {
    return {
      screenHeight: document.body.clientHeight - 55 - 180,
      country: '1',
      updateTime: null,
      tableData: []
    }
  },
  activated() {
    this.queryDataList();
  },
  methods: {
    setRowStyle: function ({
      row,
      rowIndex
    }) {
      if (row.shopName === 'MOLOVA' || row.brand === 'Brand: MOLOVA') {
        return {
          'background-color': '#fff7a3'
        }
      }
      return ''
    },
    getQueryParams() {
      let params = {
        country: this.country,
        timeStamp: new Date().getTime()
      }
      return params;
    },
    handleClick(tab, event) {
      this.queryDataList();
    },
    queryDataList() {
      rankModules.shopList(this.getQueryParams()).then((res) => {
        if (res.result != 1) {
          this.tableData = [];
        }
        if (this.country != res.mdata.country) {
          return;
        }
        this.updateTime = res.mdata.date || '';
        this.tableData = res.ldata;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.top-box {
  height: 50px;
  line-height: 50px;
  border-left: 1px solid #ededed;
  border-right: 1px solid #ededed;
  padding-left: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.el-tabs {
  border-left: 1px solid #ededed;
  border-right: 1px solid #ededed;
  border-top: 1px solid #ededed;
  padding-left: 15px;
}
.el-table {
  margin-top: -15px;
}
</style>
